<script setup lang="ts">
import type { ProductLineDetail } from '~/types/api'

const props = defineProps<{
  line: ProductLineDetail
}>()
</script>

<template>
  <ProductGallery :line="props.line" />
</template>

<style scoped></style>
